import React, { useEffect } from "react";
import Header from "../Layout/Header";
import julian from "../../Images/julian.jpg";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import Footer from "../Layout/Footer";
import { gpColors } from "../../constants/colors";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    padding: "30px",
    position: "relative",
    marginTop: "75px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "105px",
    },
  },
  filterHeader: {
    fontWeight: 900,
    fontSize: "20px",
    height: "53px",
    background: "#36404b",
    margin: "0px",
    lineHeight: "58px",
    letterSpacing: "1px",
    textAlign: "center",
    color: "#fff",
    position: "relative",
    minWidth: "250px",
    marginBottom: "30px",
    display: "inline-block",
    "&:before": {
      content: "''",
      left: "-20px",
      borderStyle: "solid",
      borderWidth: "0 0 53px 20px",
      borderColor: `transparent transparent ${gpColors.logoBrown} transparent`,
      position: "absolute",
    },
    "&:after": {
      content: "''",
      right: "-20px",
      borderStyle: "solid",
      borderWidth: "53px 20px 0 0",
      borderColor: `${gpColors.logoBrown} transparent transparent transparent`,
      position: "absolute",
    },
  },
  root: {
    display: "none",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  gridList: {
    width: "100%",
    height: "100%",
    padding: "0px",
  },
  titleBar: {
    background:
      "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
    cursor: "pointer",
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },

  mobileRoot: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  img: {
    cursor: "pointer",
    height: "160px",
    marginTop: "20px",
    width: "auto",
  },
  imgTitle: {
    backgroundColor: "#36404b",
  },
  button: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    padding: "3px",
    textTransform: "none",
    marginRight: theme.spacing(2),
  },
}));
const FilterLookup = () => {
  const classes = useStyles();
  const params = useLocation();
  console.log(params);
  const partData = params.state.partData;

  useEffect(() => {
    console.log("rendered");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [partData]);

  return (
    <div>
      <Header />
      <div className={classes.container}>
        {params.state.partData.length > 0 && (
          <div>
            {/* <div style={{textAlign:'center'}}>
            <div className={classes.filterHeader}>
                 Air Filter
            </div>
            </div>
             
             <div className={classes.filterContent}>
             GuardPlus Autocomp engine air filters are built to provide optimal engine performance while removing harmful particles and ensuring high airflow.
   
             </div> */}

            <div className={classes.root}>
              <GridList
                cellHeight={240}
                cols={4}
                spacing={40}
                className={classes.gridList}
              >
                {partData.map((tile, i) => (
                  <GridListTile key={i}>
                    <img
                      src={julian}
                      alt={""}
                      className={classes.img}
                      loading="lazy"
                    />
                    <GridListTileBar
                      title={tile.part_number}
                      className={classes.imgTitle}
                      actionIcon={
                        <Button className={classes.button}>view</Button>
                      }
                    />
                  </GridListTile>
                ))}
              </GridList>
            </div>

            <div className={classes.mobileRoot}>
              <GridList
                cellHeight={250}
                cols={1}
                spacing={20}
                className={classes.gridList}
              >
                {partData.map((tile, i) => (
                  <GridListTile key={i}>
                    <img
                      src={julian}
                      alt={""}
                      className={classes.img}
                      loading="lazy"
                    />
                    <GridListTileBar
                      title={tile.part_number}
                      className={classes.imgTitle}
                      actionIcon={
                        <Button className={classes.button}>view</Button>
                      }
                    />
                  </GridListTile>
                ))}
              </GridList>
            </div>
          </div>
        )}
        {params.state.partData.length === 0 && (
          <div
            style={{
              margin: "20px",
              border: "1px solid gray",
              fontSize: "20px",
              padding: "10px",
            }}
          >
            There is no information available on the part number you submitted.
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};
export default FilterLookup;
